import dynamic from "next/dynamic";
import { InsightShareProps } from "./InsightShare";

const DynamicInsightShare = dynamic<InsightShareProps>(
  () => import("components/InsightShare/InsightShare"),
  {
    ssr: false,
  }
);

export default DynamicInsightShare;
